import { render, staticRenderFns } from "./CustomizedGiftReview.vue?vue&type=template&id=023f100e&scoped=true"
import script from "./CustomizedGiftReview.vue?vue&type=script&lang=js"
export * from "./CustomizedGiftReview.vue?vue&type=script&lang=js"
import style0 from "./CustomizedGiftReview.vue?vue&type=style&index=0&id=023f100e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023f100e",
  null
  
)

export default component.exports